import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import ModalBody from '@atlaskit/modal-dialog/modal-body';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Stack from '@atlaskit/primitives/stack';
import { xcss } from '@atlaskit/primitives/xcss';
import ProgressBar from '@atlaskit/progress-bar/progress-bar';

import { NavigationLockout } from '@confluence/navigation-lockout';

const i18n = defineMessages({
	loadingTitle: {
		id: 'bulk-permissions.space.loading-title',
		defaultMessage: 'We’re processing your change',
		description:
			'Title text displayed in the loading dialog while bulk permissions changes are being processed',
	},
	loadingDialogDescription: {
		id: 'bulk-permissions.space.loading-dialog-description',
		defaultMessage: 'Don’t navigate away or refresh.',
		description: 'Loading dialog description text warning that a user should not navigate away',
	},
});

const LoadingSubSectionStyle = xcss({
	rowGap: 'space.300',
	paddingBottom: 'space.800',
});

export const LoadingDialog = (): React.JSX.Element => (
	<>
		<ModalHeader hasCloseButton={false}>
			<ModalTitle>
				<FormattedMessage {...i18n.loadingTitle} />
			</ModalTitle>
		</ModalHeader>
		<ModalBody>
			<Stack xcss={LoadingSubSectionStyle}>
				<FormattedMessage {...i18n.loadingDialogDescription} />
				<ProgressBar isIndeterminate />
			</Stack>
		</ModalBody>
		<NavigationLockout />
	</>
);
